import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
// import ExcelApi from "../../../api/excel.api";
// import MemberApi from "../../../api/memebr.api";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import TableDelBtn from "../../../component/atoms/button/tableDelBtn";
import SearchBar from "../../../component/atoms/input/searchBar";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import TableLayout from "../../../component/atoms/layout/table/tableLayout";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import TableText from "../../../component/atoms/text/table/tableText";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Pagination from "../../../component/molecules/pagination";
import TableCount2 from "../../../component/molecules/tableCount2";
import TableTab02 from "../../../component/molecules/tableTab02";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { toastMsg } from "../../../util/toastMsg";
import CouponModal from "./couponModal";
import CouponApi from "../../../api/coupon.api";

const CouponHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [keyword, setKeyword] = useState("");

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  // ----------------------------------- //
  // ---------- 마운트가 되면 ---------- //
  // --------------------------------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getCouponList();
  }, [location]);

  const [couponHistoryList, setCouponHistoryList] = useState([1]);

  const getCouponList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
      };
      let responseData = (await CouponApi.getList(data)).data.data;

      setCouponHistoryList(
        responseData.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        }),
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const isAllCheck = useMemo(() => {
    const checkedList = couponHistoryList.filter((item) => item.checked);
    return (
      checkedList.length !== 0 &&
      checkedList.length === couponHistoryList.length
    );
  }, [couponHistoryList]);

  const title = `발급 내역`;
  const subTitle = `쿠폰 발행 내역`;

  // ----- 취소
  const [cancelIdList, setCancelIdList] = useState([]);
  const [canceleteModalOpen, setCanceleteModalOpen] = useState(false);

  const cancelFunc = async () => {
    try {
      const data = {
        ids: cancelIdList,
      };
      await CouponApi.delete(data);
      toast(toastMsg.update);
      setCanceleteModalOpen(false);
      setCancelIdList([]);
      getCouponList();
    } catch (error) {
      errorHandler(error);
    }
  };

  const [selectedData, setSelectedData] = useState({});
  const [detailModalOpen, setDetailModalOpen] = useState(false);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>{title}</TableTitle>
          <TableTab02
            list={[
              {
                title: `쿠폰 발급`,
                link: route.payment_coupon_issuance,
                originLink: route.payment_coupon_issuance,
              },
              {
                title: `발급 내역`,
                link: route.payment_coupon_history,
                originLink: `${route.payment_coupon_history}`,
              },
            ]}
            style={{ marginBottom: "20px" }}
          />
          <TableTop>
            <TableCount2 text={subTitle} count={pagination.totalCount} />
            <TableSearchBtn>
              <SearchBar
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(
                      `${route.payment_coupon_history}?page=1&keyword=${encodeURIComponent(keyword)}`,
                      {
                        replace: true,
                      },
                    );
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.payment_coupon_history}?page=1&keyword=${encodeURIComponent(keyword)}`,
                    {
                      replace: true,
                    },
                  );
                }}
              />
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              {/* 쿠폰명 */}
              <col width={"260px"} />
              {/* 발급 아이디 */}
              <col width={"340px"} />
              {/* 형식 */}
              <col width={"97px"} />
              {/* 발급일 */}
              <col width={"130px"} />
              {/* 발급취소 */}
              <col width={"82px"} />
              {/* 상세보기 */}
              <col width={"78px"} />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <TableText>{"쿠폰명"}</TableText>
                </Th>
                <Th>
                  <TableText>{"발급 아이디"}</TableText>
                </Th>
                <Th>
                  <TableText>{"유형"}</TableText>
                </Th>
                <Th>
                  <TableText>{"발급일"}</TableText>
                </Th>
                <Th>
                  <TableText>{"발급취소"}</TableText>
                </Th>
                <Th>
                  <TableText>{"상세보기"}</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {couponHistoryList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{ height: "59px", background: "#fff" }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <TableText
                        style={{
                          width: "230px",
                        }}
                      >
                        {item.title}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText
                        title={(item.issuedMemberAccounts ?? []).join(", ")}
                        style={{
                          display: "block",
                          width: "320px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {(item.issuedMemberAccounts ?? []).join(", ") || "-"}
                        {item.issuedMemberCount > 0
                          ? ` (${item.issuedMemberCount}명)`
                          : ""}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {item.couponType === "PRICE" ? "금액 할인" : "%할인"}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY/MM/DD")}
                      </TableText>
                    </Td>
                    <Td>
                      {item.couponStatus === "CANCEL" ||
                      item.couponStatus === "USED" ||
                      item.couponStatus === "EXPIRED" ? (
                        <TableText>
                          {
                            {
                              CANCEL: "발급취소",
                              USED: "사용완료",
                              EXPIRED: "기간만료",
                            }[item.couponStatus]
                          }
                        </TableText>
                      ) : (
                        <TableDelBtn
                          text={"취소"}
                          style={{ marginLeft: "6px" }}
                          onClick={() => {
                            const cancelIdList = [item];
                            setCancelIdList(
                              cancelIdList.map((item) => item.id),
                            );
                            setCanceleteModalOpen(true);
                          }}
                        />
                      )}
                    </Td>
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          setSelectedData(item);
                          setDetailModalOpen(true);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.payment_coupon_history}
            queryString={`keyword=${encodeURIComponent(searchParams.get("keyword") || "")}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>

      {canceleteModalOpen ? (
        <Modal
          negative={true}
          title={"발급 취소 하시겠습니까?"}
          text={"취소된 쿠폰은 복구가 불가합니다."}
          setModalOpen={setCanceleteModalOpen}
          onClick={() => {
            cancelFunc();
          }}
        />
      ) : null}

      {detailModalOpen ? (
        <CouponModal
          data={selectedData}
          setModalOpen={setDetailModalOpen}
          listHandler={getCouponList}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default CouponHistory;
